import { render, staticRenderFns } from "./FormTruckingInvoiceStatusView.vue?vue&type=template&id=3b8fde54&"
import script from "./FormTruckingInvoiceStatusView.vue?vue&type=script&lang=ts&"
export * from "./FormTruckingInvoiceStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8fde54')) {
      api.createRecord('3b8fde54', component.options)
    } else {
      api.reload('3b8fde54', component.options)
    }
    module.hot.accept("./FormTruckingInvoiceStatusView.vue?vue&type=template&id=3b8fde54&", function () {
      api.rerender('3b8fde54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingAccountReceivable/FormTruckingInvoiceStatusView.vue"
export default component.exports